import TabMenu from '@/components/tab_menu/TabMenu.vue';
import SideBar from '@/components/side_bar/SideBar.vue';
import SettingAccount from '@/components/setting_account/SettingAccount.vue';
import SettingProfile from '@/components/setting_profile/SettingProfile.vue';

export default {
  data: () => ({
    tabMenu: {
      items: {
        accounts: {
          label: 'Accounts'
        },
        profile: {
          label: 'My Profile'
        }
      },
      currentTab: 'accounts'
    }
  }),
  components: {
    TabMenu,
    SideBar,
    SettingAccount,
    SettingProfile
  }
};
